define('models/reseller_role',['require','backbone'],function(request){

    var Backbone = require("backbone");


    return Backbone.Model.extend({
        url : function (){
            // set the endpoint for restful api for distributor roles
            return this.id ? (App.Config.apiBase + 'reseller-roles/' + this.id + '/')
                            : (App.Config.apiBase + 'reseller-roles/');
        },
        defaults : function () {
            return {
                id : null,
                role_name : "",
                customers : 1,
                customer_add : 1,
                customer_update : 1,
                customer_addNote : 1,
                customer_keyReset : 1,
                leads : 1,
                lead_add : 1,
                lead_update : 1,
                lead_addNote : 1,
                store : 1,
                store_addBasket : 1,
                licenses : 1,
                licenses_assign : 1,
                periodic_licenses : 1,
                periodic_licenses_extend : 1,
                get_payment:1,
                payments : 1,
                settings : 1,
                wallets: 1,
                timeline: 1

            };
        }
    });
});
